import { render } from "./google-business-messages.vue?vue&type=template&id=1aec6f62&scoped=true"
import script from "./google-business-messages.vue?vue&type=script&lang=js"
export * from "./google-business-messages.vue?vue&type=script&lang=js"

import "./google-business-messages.vue?vue&type=style&index=0&id=1aec6f62&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aec6f62"]])

export default __exports__